import React, { useState, useEffect, memo, useCallback } from 'react';
import { Popover, Box, Typography } from '@material-ui/core';

import useStyles from './styles';

const RatingComment = ({ anchor, comment }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setAnchorEl(anchor.current);
  }, [anchor]);

  const handlePopoverOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handlePopoverClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (anchorEl) {
      anchorEl.addEventListener('mouseenter', handlePopoverOpen);
      anchorEl.addEventListener('mouseout', handlePopoverClose);
    }
    return () => {
      if (anchorEl) {
        anchorEl.removeEventListener('mouseenter', handlePopoverOpen);
        anchorEl.removeEventListener('mouseout', handlePopoverClose);
      }
    };
  }, [anchorEl, handlePopoverClose, handlePopoverOpen]);

  return (
    <Popover
      className={classes.container}
      open={open}
      onClose={handlePopoverClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box className="comment-content">
        <Typography className="comment-title" variant="overline">
          Seu comentário:
        </Typography>
        <Typography className="comment-msg" variant="caption">
          {comment}
        </Typography>
      </Box>
    </Popover>
  );
};

export default memo(RatingComment);
